// LIST
export const FETCH_NOTIFICATION = "app/NOTIFICATION/FETCH_NOTIFICATION";
export const FETCH_NOTIFICATION_SUCCESS =
  "app/NOTIFICATION/FETCH_NOTIFICATION_SUCCESS";
export const FETCH_NOTIFICATION_FAILURE =
  "app/NOTIFICATION/FETCH_NOTIFICATION_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/NOTIFICATION/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/NOTIFICATION/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/NOTIFICATION/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_NOTIFICATION = "app/NOTIFICATION/ADD_NOTIFICATION";
export const ADD_NOTIFICATION_SUCCESS =
  "app/NOTIFICATION/ADD_NOTIFICATION_SUCCESS";
export const ADD_NOTIFICATION_FAILURE =
  "app/NOTIFICATION/ADD_NOTIFICATION_FAILURE";

// EDIT
export const EDIT_NOTIFICATION = "app/NOTIFICATION/EDIT_NOTIFICATION";
export const EDIT_NOTIFICATION_SUCCESS =
  "app/NOTIFICATION/EDIT_NOTIFICATION_SUCCESS";
export const EDIT_NOTIFICATION_FAILURE =
  "app/NOTIFICATION/EDIT_NOTIFICATION_FAILURE";

// DELETE
export const DELETE_NOTIFICATION = "app/NOTIFICATION/DELETE_NOTIFICATION";
export const DELETE_NOTIFICATION_SUCCESS =
  "app/NOTIFICATION/DELETE_NOTIFICATION_SUCCESS";
export const DELETE_NOTIFICATION_FAILURE =
  "app/NOTIFICATION/DELETE_NOTIFICATION_FAILURE";
